<template>
    <div class="tns-carousel-outer">
        <div class="tns-carousel" ref="slider">
            <slot></slot>
        </div>
        <div ref="arrows" class="tns-carousel-arrows">
            <button class="prev slider-btn  button"><i class="icons8-featured-left-arrow-01"
            ></i>
            </button>
            <button class="next slider-btn  button"><i class="icons8-featured-right-arrow-01"
            ></i>
            </button>
        </div>
    </div>
</template>

<script>
    import {tns} from 'tiny-slider/src/tiny-slider.module'

    export default {
        name: 'full-width-slider',
        mounted() {
            this.slider = tns({
                container: this.$refs.slider,
                nav: false,
                controlsContainer: this.$refs.arrows,
                autoplay: true,
                autoplayText: false,
                autoplayButton: false,
                autoplayButtonOutput: false

            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";

    .tns-carousel-arrows {
        display: flex;
        justify-content: flex-end;
        margin-right: 20%;
    }

    .slider-btn {
        background-color: #000;
        width: 54px;
        height: 56px;
        border: none;
        color: white;
        outline: none;

        @media (max-width: $tablet) {
            display: none;
        }


    }

    .prev {
        background-color: $silver;

        &:hover {
           // background-color: $ice ;
        }
    }

    .next {
        &:hover {
            background-color: $darker-gray ;

        }
    }

    .button {
        i {
            font-size: 24px;
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/sliders/FullWidthSlider.vue